/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TextField } from '@material-ui/core';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { UnitAdjustmentTableHead } from './TableHead';
import PaginationBox from './PaginationBox';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { getNdcGridData, setPaginationIndex } from '../Store/action';
import { normalizeDate } from '../../../../SharedModules/utilities/utilities';

const DisplayUnitAdjustment = () => {
  const {
    isLoading,
    displayObj: {
      selectReportValue,
      adjustmentTypeValue,
      rebateProgramName,
      quarterFrom: getQuarter,
      fromDateValue,
      endDateValue,
      allRebateValue,
      gridData,
      allRebateProgram,
      countValue,
    },
  } = useSelector((state) => state?.sharedState?.AdjustmentReducer);

  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [gridDataList, setGridDataList] = React.useState([]);
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [filterApply, setFilterApply] = React.useState(false);
  const [applyPagination, setApplyPagination] = React.useState(false);
  // handling full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  // pagination
  const paginationLength = allRebateValue?.length || 1;
  const [count, setCount] = React.useState(countValue || 1);
  const [paginationArray, setPaginationArray] = React.useState([
    ...Array(paginationLength).keys(),
  ]);

  useEffect(() => {
    setCount(countValue || 1);
    setApplyPagination(true);
  }, [countValue]);

  /*
    This function handle the side effect of next previios of pagination box
  */
  const handleClick = (type, value) => {
    if (type === 'next') {
      dispatch(setPaginationIndex(count + 1));
    }

    if (type === 'previous') {
      dispatch(setPaginationIndex(count - 1));
    }

    if (type === 'change') {
      if (value < 1 || value > paginationArray.length) {
        dispatch(setPaginationIndex(paginationArray.length));
      } else {
        dispatch(setPaginationIndex(value));
      }
    }
  };

  // this function handle the vlue like text in input box
  const handleBlur = async (value) => {
    if (
      value < 1 ||
      parseInt(value) > paginationArray.length ||
      value === '' ||
      isNaN(value)
    ) {
      dispatch(setPaginationIndex(0));
      await Promise.resolve();
      // setTimeout(() => {
        value < 1
          ? dispatch(setPaginationIndex(1))
          : dispatch(setPaginationIndex(paginationArray.length));
      // }, 20);
    } else {
      dispatch(setPaginationIndex(parseInt(value)));
    }
  };
  // Already calling this API in onClickOnSearch click event, so below useEffects not required
  // let rebateProgramNameCd =
  //   allRebateValue?.map((obj) => obj.rebateProgramCd) ?? [];

  React.useEffect(() => {
    let payload = {};
    if (applyPagination) {
      if (selectReportValue == 'Paid Quarter') {
        payload = {
          rebateProgramCd: allRebateValue[count - 1]?.rebateProgramCd,
          aiAllRpc: 0,
          paidQtr: getQuarter,
        };
      } else {
        payload = {
          rebateProgramCd: allRebateValue[count - 1]?.rebateProgramCd,
          aiAllRpc: 0,
          startDate: fromDateValue,
          endDate: endDateValue,
          adjustmentTyep: adjustmentTypeValue,
        };
      }
      dispatch(getNdcGridData(payload));
    }
  }, [count]);

  React.useEffect(() => {
    let data = gridData?.unitAdjustmentsNDCLevelGridReportVOList;
    data = data?.map((item) => {
      let notes = item?.comments
      if (item?.comments.length > 5) {
        notes = notes?.toString()?.replaceAll(/\n/g, ' ');
        notes = notes?.toString()?.replaceAll(/\r/g, '')
      }
      return {
        ...item,
        notes: notes?.trim(),
        unitRebateAmt: item.unitRebateAmt
          ? parseFloat(item.unitRebateAmt)?.toFixed(4)
          : '0.00',
        adjustedTotalAmt: item.adjustedTotalAmt
          ? parseFloat(item.adjustedTotalAmt)?.toFixed(2)
          : '0.00',
        changeNumOfUnits: item.changeNumOfUnits
          ? parseFloat(item.changeNumOfUnits)?.toFixed(4)
          : '0.0000',
      };
    });
    setGridDataList(data);
  }, [gridData]);
  // rebate program name

  const rebateProgramNameValue =
    allRebateValue?.map((obj) => obj.rebateProgramName) ?? [];
  const HeaderName = allRebateValue?.find(
    (item) =>
      item.rebateProgramCd ===
      rebateProgramNameValue[count - 1]?.split(' - ')[0]
  );
  // TO get the complete name of the rebate program in textfield and PDF header

  const rebateProgramNameValue1 = HeaderName?.rebateProgramName;
  const header1 = HeaderName?.invoiceHdrLine1;
  const header2 = HeaderName?.invoiceHdrLine2;
  const header3 = HeaderName?.invoiceHdrLine3;
  // pdf header
  const firstInfo = '';
  const eighthInfo = `Rebate Program Code : ${rebateProgramNameValue[count - 1]
    }`;

  const thirdInfo = `Period: ${selectReportValue == 'Adjustment Type/Dates'
    ? `${fromDateValue}-${endDateValue}`
    : getQuarter
    }`;

  const fourthInfo = header1;
  const fifthInfo = '';
  const sixthInfo = header2;
  const ninethInfo = header3;
  // filter total
  // filter total
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };
  // pinned row

  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : gridDataList;

    if (property === 'checkLogNum') {
      const data = displayedRows.length;

      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    if (property === 'unitRebateAmt'){
      return data ? parseFloat(data)?.toFixed(4) : '0.0000';
    }
    return data ? parseFloat(data)?.toFixed(2) : '0.00';
  };

  const createData = (count1, prefix) => {
    const result = [];
    for (let i = 0; i < count1; i += 1) {
      result.push({
        isBottomRow: true,
        ndc: 'Total',
        changeNumOfUnits: parseFloat(sum('changeNumOfUnits'))?.toFixed(4),
        // unitRebateAmt: sum('unitRebateAmt'),
        adjustedTotalAmt: sum('adjustedTotalAmt'),
      });
    }

    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [gridDataList, filteredRows]);
  const endDate = normalizeDate(endDateValue,'to')
  const startDate= normalizeDate(fromDateValue,'from')
  return (
    <div className="tabs-contaitBillPanel custom-check tabs-container">
      <Spinner load={isLoading} />
      <CustomSeparator
        parent1="State Reports"
        parent2="Display Unit Adjustments at NDC level"
      />{' '}
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row mb-5">
              <div className="col-12">
                <PaginationBox
                  array={paginationArray}
                  count={count}
                  handleClick={handleClick}
                  handleBlur={handleBlur}
                />
              </div>
            </div>
            <div className="panel custom-fieldset">
              <div className="custom-check">
                <div className="form-wrapper">
                  <div className="mui-custom-form input-md ">
                    <div className="col-12">
                      <TextField
                        id="Rebate_Program"
                        label="Rebate Program"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Rebate_Program' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={rebateProgramNameValue[(count || 1) - 1]}
                        disabled
                      />
                    </div>
                  </div>
                  {selectReportValue == 'Paid Quarter' && (
                    <div className="mui-custom-form input-md">
                      <div className="col-12">
                        <TextField
                          label="Paid Quarter"
                          id="PaidQuarter-1"
                          fullWidth
                          placeholder=""
                          inputProps={{ id: 'PaidQuarter-1' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={getQuarter}
                        />
                      </div>
                    </div>
                  )}
                  {selectReportValue == 'Adjustment Type/Dates' && (
                    <div className="mui-custom-form input-md">
                      <div className="col-12">
                        <TextField
                          label="Adjustment Date Range "
                          id="Adjustment_Date_Range "
                          fullWidth
                          placeholder=""
                          inputProps={{ id: 'Adjustment_Date_Range' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={`${startDate}-${endDate}`}
                        />
                      </div>
                    </div>
                  )}
                  {selectReportValue == 'Adjustment Type/Dates' && (
                    <div className="mui-custom-form input-md">
                      <div className="col-12">
                        <TextField
                          label="Adjustment Type "
                          id="Adjustment_Type "
                          fullWidth
                          placeholder=""
                          inputProps={{ id: 'Adjustment_Type' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={adjustmentTypeValue}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        <div className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold">
          <TableGridWithFeatures
            data-testid="Unit-Adjustment-at-NDC-Level"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            rowData={gridDataList}
            columnDefs={UnitAdjustmentTableHead}
            exportFile
            animateRows
            sideBar={false}
            defaultCol={{
              wrapHeaderText: true,
              autoHeaderHeight: true,
            }}
            reportName="Unit Adjustments at NDC Level Report"
            fileName="UnitAdjAtNDCLvl"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            countValue={count}
            isScrollOn
            defaultColWidth={200}
            onFilterData={onFilterChanged}
            getFilterApply={getFilterApply}
            onCellFocused={onCellFocused}
            hideColumnsInPdf
            pinnedBottomRowData={pinnedBottomRowData}
            frameworkComponents={{
              TextBoxRender: (cellInfo) => {
                const name = cellInfo?.value;
                if (name && name.length > 20) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name && `${name.substring(0, 20)}...`}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
            info={{
              firstInfo,
              thirdInfo,
              fourthInfo,
              fifthInfo,
              sixthInfo,
              ninethInfo,
              eighthInfo,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default DisplayUnitAdjustment;
